// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"388":"a4fe211c","545":"504c0dd5"}[chunkId] + ".chunk.css";
};